import React from 'react';
import Configs from "../../components/Admin/Configs";

const ConfigsPage = () => {
  return <Configs />;
};

export default ConfigsPage;
